import React, { createContext, useContext } from 'react';

export const defaultContent = (position) => {
  return {
    name: '',
    icon: null,
    title: '',
    navigationTracker: [],
    drawerContent: null,
    position: (position || 'right'),
    open: false,
    isUpdating: false
  };
};

export const DrawerContext = createContext(defaultContent());

export const useDrawerContext = () => {
  return useContext(DrawerContext);
};
